<template>
     <div class="search_wrap">
            <div class="search_wrap box" :style="'min-height:'+screenHeight*0.7+'px' ">
                <h1 >法律法规数据库检索</h1>

                <p   style="width:50%;text-align: center;">    
                    <span @click="ChooseOption" id='law0' class="picker_status"  name="searchitem">全库</span >
                    <span @click="ChooseOption" id="1" name="searchitem" style="margin-left:10px;">法律法规</span>
                    <span @click="ChooseOption" id="2" name="searchitem" style="margin-left:10px">地方法规</span> 
                    <span @click="ChooseOption" id="3" name="searchitem" style="margin-left:10px;">司法解释</span> 
                
                </p>
                
                <!-- <div class=" inputbox"  >
                    <el-input :placeholder="placeholder" v-model="inputValue" class="input-with-select">
                        <el-button slot="append" type="primary" icon="el-icon-search"  @click="SearchEvent()">搜索</el-button>
                    </el-input>    
                </div> -->
                <div style="width:70%">
                    <el-input :placeholder="placeholder" v-model="inputValue"  @keyup.enter.native="SearchEvent()" >
                        <el-button slot="append" type="primary" icon="el-icon-search"   @click="SearchEvent()">搜索</el-button>
                    </el-input>   
                </div> 


                <div class="caseType" >
           
                    <el-radio-group v-model="search_type" >
                            <el-radio label="title" style="line-height: 45px">按标题检索</el-radio>
                            <el-radio label="content" style="line-height: 45px">按正文检索</el-radio>
                            <!-- <el-radio label="行政案件" style="line-height: 45px">行政案件</el-radio>
                            <el-radio label="赔偿案件" style="line-height: 45px">赔偿案件</el-radio>
                            <el-radio label="执行案件" style="line-height: 45px">执行案件</el-radio> -->
                    </el-radio-group>
  

                </div>


                <div class='listwrap'>
                    <div class='result_bar'>
                        为您检索到  {{number}} 个结果
                    </div>


                    <div class='list_box'  v-for="(item,index) of resultList" v-bind:key="item._id"    >
                        <!-- @click="TurnToDetail" -->
                        
                         <!-- :to="'/law/'+item._id" target='_blank' style="  text-decoration: none;color:black" -->
                        <div> 
                            <div class='casetitle' :data-md5="item._source.md5"   @click="TurnToDetail(item._id)" > {{(page-1)*20+index+1}}.  {{item._source.name}}</div>
                            <div class='baseinfo' :data-md5="item._source.md5">
                                <div style="width:50%" :data-md5="item._source.md5">发布单位: {{item._source.department}}</div> 
                                <div :data-md5="item._source.md5">发布时间： {{item._source.date}} </div> 
                                
                            </div>

                            <div    > 
                            
                                <span style="float:right;" >  
                                    <el-dropdown :data-docid="item._id" @command="ManageArticleHandle" >
                                        <el-button size='mini' plain type="info"   style="padding-left:10px;padding-right:10px"   >操作<i class="el-icon-arrow-down el-icon--right"></i></el-button> 
                                    
                                        <el-dropdown-menu slot="dropdown"  :data-docid="item._id" :data-ind="index">
                                            <el-dropdown-item :command="'modifyTitle,'+item._id+','+index"  >修改标题</el-dropdown-item>

                                            <el-dropdown-item :command="'modify,'+item._id" >编辑</el-dropdown-item>
                                            <el-dropdown-item :command="'delete,'+item._id">删除</el-dropdown-item>
                                            <el-dropdown-item :command="'invisible,'+item._id">设置不显示</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </span>
                                
                            </div>
                       
                        </div>

                        <!-- <div class='casetitle' :data-md5="item._source.md5"> {{(page-1)*20+index+1}}.  {{item._source.name}}</div>
                        <div class='baseinfo' :data-md5="item._source.md5">
                            <div style="width:50%" :data-md5="item._source.md5">发布单位: {{item._source.department}}</div> 
                            <div :data-md5="item._source.md5">发布时间： {{item._source.date}} </div> 
                            
                        </div> -->
                      
                    
                    </div>



                </div>

                 <!-- :before-close="handleClose" -->
                <el-dialog
                    title="提示"
                    :visible.sync="dialogVisible"
                    width="30%"
                    >
                    <!-- <span>这是一段信息</span> -->
                    <el-input v-model="titleInput" placeholder="请输入内容"></el-input>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible = false">取 消</el-button>
                        <el-button type="primary" @click="modifyTitleHandle">确 定</el-button>
                    </span>
                </el-dialog>
    


            </div>

            <div class="bottom">
                <div class="bottom left">
                    *数据来源于最高人民法院、各政府公开网站等
                </div>
                <div class="bottom right">
                    <Pages :pageTotal="number>200? 200: number" :pageSize="20"    @ChangePage="ChangeListPage"></Pages>

                </div>
                <!-- <a href="javascript:void(0)" @click="open_blank"></a> -->

            </div>
          

        </div>
</template>

<script>
import Pages from '../Pages.vue'

export default {
        name: 'lawlib',
        metaInfo: {
            title: '法律法规数据库检索', // set a title
            meta: [{                 // set meta
                name: 'keywords',
                content: '法律查询,司法解释,法规查询,找律师,法律工具'
            }],
      
        },
		// props: {
		// 	pageId: String
        // },
        components: {
            Pages
        },
        mounted: function () {
            window.console.log('wenshu created')
            document.getElementById('law0').style.color="#409EFF";
            this.SearchEvent()
            // if(this.$root.islogin==false){
            //     const h = this.$createElement;
            //     this.$notify({
            //         title: '注意',
            //         message: h('i', { style: 'color: teal'}, 'Hi，本功能需要登录后才可以使用哟')
            //     });
            // }
          

        },
        data() {
			return { 
                screenWidth:window.innerWidth,
                screenHeight:window.innerHeight,
                dialogVisible:false,
                // placeholder:'输入案件名称、案号、律师等进行查询',
                placeholder:'请输入关键词，不少于两个字',
                inputValue:'',//输入框内容

                //search 参数
                // law_radio_type:'1',
                // lawlib_range:['全库', '法律', '行政法规', '国务院部门规章', '地方性法规', '地方政府规章', '司法解释' ],
                // lawlib_range_value:'1',
                
                // PhoneMode:'',
                // v_PhoneMode:false,
                // iconname_style:'iconname',
                search_type:'title',
                resultList:[],
                number:0,
                page:1,
                sumList:{},
                param:{},
                titleInput:'',
              
            }
        },
        methods:{
            ManageArticleHandle(command){
                var para=command.split(',')
                window.console.log(para)
                if (para[0]=='modify'){
                    let routeData = this.$router.resolve({name:'law_draft', params: {id: para[1]} });


                    window.open(routeData.href, '_blank')
                    // this.$router.push({name:'my_draft',params: {id:para[1]}})
                }
                else if(para[0]=='delete'){
                
                    this.ConfirmDelete(para[1]) 

                } else  if (para[0]=='modifyTitle'){
                    this.dialogVisible=true
                    let _id=para[1]
                    let ind=para[2]
                    this.titleInput=this.resultList[ind]._source.name

                    this.modify_ind=parseInt(ind)
                    this.modify_id=_id
                    // let routeData = this.$router.resolve({name:'my_draft', params: {id: para[1]} });
                    // window.open(routeData.href, '_blank')
                    // this.$router.push({name:'my_draft',params: {id:para[1]}})
                }
                else  if (para[0]=='invisible'){  // 设置不显示 onshow 设置为no
                    this.dialogVisible=true
                    let _id=para[1]
                    let ind=para[2]
                    // this.titleInput=this.resultList[ind]._source.name

                    this.modify_ind=parseInt(ind)
                    this.modify_id=_id
                    // let routeData = this.$router.resolve({name:'my_draft', params: {id: para[1]} });
                    // window.open(routeData.href, '_blank')
                    // this.$router.push({name:'my_draft',params: {id:para[1]}})
                }


                 


                 
                 

            },
            modifyTitleHandle(){
                var that=this 
                var data={
                    name:this.titleInput,
                    _id:this.modify_id,
                    whattodo:'change_law_name'
                }
                this.axios.post(this.$root.rootUrl+'admin',data
                ).then(function (res) {

  
                    if(res.status==200){

                        let result=res.data 
                        if(result.status=='badgate'){
                            that.$message({
                                message: '请先登录哦',
                                type: 'warning'
                            });
                        }else  if(result.status=='ok'){
                           that.$message({
                                message: 'ok',
                                type: 'success'
                            });
                            that.dialogVisible=false
                            that.resultList[ind]._source.name=that.titleInput
                        }else  if(result.status=='fail'){
                            that.$message.error(result.failMsg);
                            that.dialogVisible=false
                        } 




                   
                    }
                    // loading.close();
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                    // loading.close();
                });

            },

            bindPickerChange(e){
                this.index=e.detail.value;
            },
            resetEvent(){
                this.s3=0;
                this.date1='';
            },
            bindcalculate: function () {
                if(!this.date1){
                    alert('日期记得选择哦');
                    return false;
                }
                this.s3=(this.date1[1]-this.date1[0])/86400000;
            },
            ChooseOption(e){
                var id=e.target.id
                var x=document.getElementsByName('searchitem')
                window.console.log('x=',x)
                window.console.log(' x.length=', x.length)
                for (var i of x){

                    i.style.color="#000000";
                }
            
                // document.getElementsByName('searchitem')[0].style.backgroundColor="#dedede";
                window.console.log('ok')

                // document.getElementById(id).style.backgroundColor="#F2F6FC";
                document.getElementById(id).style.color="#409EFF";

                this.chooseOption=id

                window.console.log('this.chooseOption=',this.chooseOption)
                window.console.log('this.placeholder=',this.placeholder)
                    
            },


            SearchEvent(){
                var param={}
                // if(!this.$root.islogin){
                //     this.$message({
                //         message: '请先登录哦',
                //         type: 'warning'
                //     });
                //     return
                // }
                this.page=1
                var that=this;
                // if (this.inputValue.length<2){
                //     this.$message({
                //         message: '关键词不得少于两个字符哦',
                //         type: 'warning'
                //     });
                //     return
                // }

                
                var param={"keyWord":this.inputValue,"page":this.page,"source":that.search_type};

                if (this.chooseOption!='law0'){
                    param['lawtype']=this.chooseOption
                }

               
                that.param=param
                var data= { 
                    param:param,
                    whattodo: "lawlib_getList"
                }

  

                this.axios.post(this.$root.rootUrl+'mini_app',data
                ).then(function (res) {

                 // const loading = this.$loading({
                //     lock: true,
                //     text: 'Loading',
                //     spinner: 'el-icon-loading',
                //     background: 'rgba(0, 0, 0, 0.7)'
                // });indow.console.log(res)
                    if(res.status==200){

                        let result=res.data 
                        if(result.status=='badgate'){
                            that.$message({
                                message: '请先登录哦',
                                type: 'warning'
                            });
                        }else  if(result.status=='ok'){
                            that.number=res.data.number
                            that.resultList=res.data.data
                            // window.console.log( that.resultList)
                            that.sumList={1:res.data.data}
                        }else  if(result.status=='fail'){
                            that.$message.error(result.failMsg);
                        }else  if(result.status=='noresult'){
                            that.number=0
                            that.resultList=[]
                        }




                   
                    }
                    // loading.close();
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                    // loading.close();
                });


            },

            ChangeListPage(page){
                var that=this
                this.page=page
                // var _page=page.toString()
                // window.console.log('_page:',_page);
                window.console.log('sumList:',that.sumList);

                if(that.sumList[page]){
                    window.console.log('this page exist');
                    that.resultList=that.sumList[page]
                    return
                }else{

                    // that.para['page']=page

                    // var data= { 
                    //     para: that.para,
                    //     param:that.param,
                    //     whattodo: "wenshu_getList"
                    // }
                    var param=that.param
                    param['page']=page
                    var data={}
                    data['param']=that.param
                    data['whattodo']='lawlib_getList'
                    this.axios.post(this.$root.rootUrl+'mini_app',data
                    ).then(function (res) {

                        window.console.log(res)
                        if(res.status==200){

                            let result=res.data 
                            if(result.status=='badgate'){
                                that.$message({
                                    message: '请先登录哦',
                                    type: 'warning'
                                });
                            }else  if(result.status=='ok'){
                                that.number=res.data.number
                                that.resultList=res.data.data
                                that.sumList[page]=res.data.data
                            }else  if(result.status=='fail'){
                              that.$message.error(result.failMsg);
                            }else  if(result.status=='noresult'){
                              that.number=0
                              that.resultList=[]
                            }



                            // noresult



                            
                        }
                        
                    
                        
                    }).catch(function (error) {
                        window.console.log(error);
                    });



                }



            },


            TurnToDetail(_id){
                var that=this
                // window.console.log('e:',e)
                // window.console.log('md5',e.srcElement.dataset.md5)
                // var md5=e.srcElement.dataset.md5
                // let routeData = that.$router.resolve({name:'lawlib_detail', query: { _id: _id } });
                // window.open(routeData.href, '_blank');
                this.$router.push({  path:'law/'+_id })
            //    this.$router.push({name:'home'}
              // var data= { 
                //     param:{"md5":md5},
                //     whattodo: "lawlib_getDetail"
                // }                
                // this.axios.post('https://api.lawtip.cn',data
                // ).then(function (res) {

                //     window.console.log(res)
                //     if(res.status==200){
                //         // that.number=res.data.number
                //         // that.resultList=res.data.data
                //         var timestamp=new Date().getTime();
                //         // window.console.log(res.data.data);
                //         // sessionStorage['wenshu_detail']=res.data.data
                //         sessionStorage.setItem('law_detail', JSON.stringify(res.data.data));
                //         // window.console.log("sessionStorage['wenshu_detail']:",sessionStorage['wenshu_detail']);
                //         // window.open('http://www.lawtip.cn/lawlibDetail.html?'+timestamp, '_blank')

                //         let routeData = that.$router.resolve({name:'lawlib_detail', query: { md5: md5 } });
                //         window.console.log('routeData.href:',routeData.href)
                //         window.open(routeData.href, '_blank');
                //     }
        
                    
                // }).catch(function (error) {
                //     window.console.log(error);
        
                // });


              
                
                },

        }

       


    }
</script>

<style scoped>
    .el-select .el-input {
        width: 130px;
    }
    .el-input-group__prepend {
        background-color: #fff;
        
    }  
    .input-with-select {
        background-color: #fff;
        width:50%;
        height: 50px;
        border-radius: 5px;
    }

    .search_wrap{
        width:96%;
        min-height: 94%;
        /* padding: 15px; */
        display: flex;
        flex-direction: column;
        /* flex-wrap: wrap; */
        /* line-height: 40px; */
        /* border:1px solid #c41cc4; */
        margin-left: auto;
        margin-right: auto;
        padding: 15px;
    }


    .search_wrap.box{
        /* padding: 20px; */
        width:96%;
        min-height:500px;
        /* min-height: 99%; */
        display: flex;
        flex-direction: column;
        /* border:1px solid #bb14a5; */
        /* border:2px solid #51869c; */
        border:none;
        border-radius: 20px;
        /* margin: auto; */
        /* margin-top:10px; */
        align-items: center;

        margin-left: auto;
        margin-right:auto;
    }

    .inputbox{
       
        width:70%;
       
    
        height: 50px;
        border-radius: 5px;
        
        /* top:260px; 
        position: absolute; */
        

    }

    
.caseType {
    /* margin-top:40px; */
    /* width:750px; */
    width:95%;
    height: 80px;
    text-align: center;

    /* height: 40px; */
    vertical-align: center;
    /* top:340px;
    position: absolute; */
    /* margin-left: 60px; */

    /* border:1px solid #50b66f; */
}


.listwrap{
    width:70%;
    min-height:200px ;
    /* border:1px solid #d6961f;  */

       /* width:95%; */
    /* margin-top:30rpx; */
    margin-left: auto;
    margin-right:auto;
    display: flex;
    flex-direction: column;
}

.result_bar{
  width: 99.5%;
  height: 28px;
  font-size:16px;
  line-height: 28px;
  /* background-color: #c2bfbf; */
  background: #37474f;
  color: #fff;
  padding-left: 10px;
  overflow: hidden;
}

.list_box{
  margin-bottom:10px;
  border:1px dashed #222;
  margin-top:10px;
  padding: 10px;

  /* border:1px solid #d6961f;  */

}

.casetitle{
    width: 100%;
    font-weight: bold;
    font-size:22px;
    text-align: left;
    cursor: pointer;
}
.baseinfo{
    width:100%;
    font-size:18px;
    margin-top:5px;
    margin-bottom:5px;
    padding-left: 10px;
    padding-right: 15px;
    border-left:1px solid #ccc;
    display: flex;
    flex-direction: row;
    text-align: left;
    
}

.casebrief{
    display: flex;
    min-height: 20px;
    max-height: 160px;
    border:1px solid #ccc;
    width:98%;
    margin-left:auto;
    margin-right:auto;
    font-size:18px;
    line-height: 20px;
    padding: 8px;
    overflow: hidden;
}
.keyword{
    width:100%;
    font-size:16px;
    margin-bottom:5px;
}



.bottom{
    display: flex;
    flex-direction: row;
    width:100%;
    height: 30px;
    line-height: 30px;
    margin-top:4px;
    /* border:1px solid #50b66f;  */
    font-size:13px;
}
.bottom.left{
    width:65%;
    /* border:1px solid #953ba7;  */
    padding-left: 14px;
}
.bottom.right{
    width:35%;
    /* border:1px solid #c9c62e;  */

}


</style>
